import { Component, Inject, Input } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { DialogData } from './dialog-data.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
})
export class DeleteDialogComponent {
  @Input() title: string;

  isLoading = false;

  constructor(
    public readonly dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: DialogData & {
      userId: string;
      licenseId: string;
    },
    public readonly translate: TranslateService
  ) {}

  get description() {
    if (!this.data.description) {
      return '';
    }

    return this.data.description;
  }

  async delete() {
    if (!this.data.onPrimaryClick) {
      return;
    }
    this.isLoading = true;
    await this.data.onPrimaryClick();
    this.isLoading = false;
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
